export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-latin-ext-600-normal.woff2?099941a80f36cfba9abe03b7da991120";